<template>
  <div class="container-fluid py-4">
    <!-- Filter Section -->
    <div class="card mb-4">
      <div class="card-body">
        <div class="row align-items-center mb-3">
          <div class="col-lg-3 col-md-6 col-sm-12 mb-2 mb-lg-0">
            <label class="form-label mb-2 font-weight-bolder">Merchant</label>
            <select
              id="merchantId"
              class="form-select custom-select p-2"
              v-model="merchantId"
              @change="handleFilterChange"
            >
              <option value="0">Select merchant</option>
              <option
                v-for="merchant in merchants"
                :key="merchant.id"
                :value="merchant.id"
              >
                {{ merchant.brand_name }}
              </option>
            </select>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 mb-2 mb-lg-0"></div>
          <div class="col-lg-3 col-md-6 col-sm-12 mb-2 mb-lg-0"></div>
          <div class="col-lg-3 col-md-6 col-sm-12 mb-2 mb-lg-0">
            <label class="form-label mb-2 font-weight-bolder">Export</label>
            <select
              id="exportFormat"
              class="form-select custom-select p-2"
              v-model="action_export"
              @change="exportFile"
            >
              <option value="0">Select format</option>
              <option value="excel">Excel (.xlsx)</option>
              <option value="csv">CSV (.csv)</option>
            </select>
          </div>
        </div>
        <form @submit.prevent="search" role="form">
          <div class="row align-items-center">
            <div class="col-lg-9 col-sm-12 mb-2 mb-lg-0">
              <div class="input-group input-group-outline">
                <input
                  id="search"
                  type="text"
                  placeholder="Search here..."
                  class="form-control"
                  v-model="searchKeyword"
                />
              </div>
            </div>
            <div class="col-lg-3 col-sm-12">
              <material-button
                type="submit"
                class="btn btn-primary toast-btn"
                variant="gradient"
                color="success"
                fullWidth
              >
                Search
              </material-button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Table Section -->
    <div class="card">
      <div class="card-body px-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Row No
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Member ID
                </th>
                <th
                  class="text-center text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Phone No
                </th>
                <th
                  class="text-center text-uppercase text-xxs font-weight-bolder opacity-7"
                >
                  Topup
                </th>
                <th
                  class="text-center text-uppercase text-xxs font-weight-bolder opacity-7"
                >
                  Bonus
                </th>
                <th
                  class="text-center text-uppercase text-xxs font-weight-bolder opacity-7"
                >
                  Cashback
                </th>
                <th
                  class="text-center text-uppercase text-xxs font-weight-bolder opacity-7"
                >
                  Wallet Balance
                </th>
              </tr>
            </thead>
            <tbody v-if="members.length">
              <tr v-for="(value, key) in members" :key="key">
                <td class="align-middle text-center text-sm">
                  <p class="text-xs font-weight-bold mb-0">{{ key + 1 }}</p>
                </td>
                <td class="align-middle text-center text-sm">
                  <p class="text-xs font-weight-bold mb-0">
                    {{ value.member_id_format }}
                  </p>
                </td>
                <td class="align-middle text-center text-sm">
                  <p class="text-xs font-weight-bold mb-0">
                    {{ value.phone_number }}
                  </p>
                </td>
                <td class="align-middle text-center text-sm">
                  <p class="text-xs font-weight-bold mb-0" :class="{ 'text-danger': value.topup < 0 }">
                    {{ value.topup_format }}
                  </p>
                </td>
                <td class="align-middle text-center text-sm">
                  <p class="text-xs font-weight-bold mb-0" :class="{ 'text-danger': value.bonus < 0 }">
                    {{ value.bonus_format }}
                  </p>
                </td>
                <td class="align-middle text-center text-sm">
                  <p class="text-xs font-weight-bold mb-0" :class="{ 'text-danger': value.cashback < 0 }">
                    {{ value.cashback_format}}
                  </p>
                </td>
                <td class="align-middle text-center text-sm">
                  <p class="text-xs font-weight-bold mb-0" :class="{ 'text-danger': value.amount_in_account < 0 }">
                    {{ value.amount_in_account_format}}
                  </p>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7" class="text-center py-4">
                  <p class="text-xs text-secondary mb-0">No members found</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <pagination
      v-if="pagination.last_page > 1"
      :pagination="pagination"
      :current_page="pagination.current_page"
      :last_page="pagination.last_page"
    />

    <!-- Snackbar Notification -->
    <div
      class="position-fixed top-1 end-1 message-success"
      style="z-index: 9999"
    >
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>

    <!-- Loading Overlay -->
    <material-loading :active="loaderActive" />

    <!-- Hidden Export Form -->
    <form
      :action="`${actionDownload}/admin/merchant/report/wallet`"
      method="POST"
      id="exportForm"
      ref="exportForm"
    >
      <input type="hidden" name="merchant_id" :value="merchantId" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="search_keyword" :value="searchKeyword" />
      <input type="hidden" name="action" value="export" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MerchantService from "../../../services/merchant.service";
import ReportService from "../../../services/report.service";
import TokenService from "../../../services/token.service";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Pagination from "@/components/Pagination.vue";
import $ from "jquery";

export default {
  name: "wallet-report",
  components: {
    MaterialButton,
    MaterialSnackbar,
    MaterialLoading,
    Pagination,
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      members: [],
      searchKeyword: "",
      merchantId: 0,
      merchants: [],
      snackbar: null,
      message: "",
      loaderActive: false,
      pagination: {},
      page: 1,
      action: "list",
      action_export: 0,
      actionDownload: process.env.VUE_APP_BASE_URL,
    };
  },
  mounted() {
    this.getMerchants();
  },
  methods: {
    exportFile() {
      if (this.merchantId && this.merchantId != 0) {
        if (this.action_export == 'excel' || this.action_export == 'csv') {
          setTimeout(() => {
            $("#downloadForm").click();
          }, 150);
        }
      } else {
        this.action_export = 0;
        this.snackbar = "danger";
        this.message = "Plese, select merchant!";
        this.setTimeOutNotification();
      }
    },
    getMerchants() {
      MerchantService.getAllMerchant().then(
        (response) => {
          this.merchants = response.data.data || [];
        },
        (error) => {
          console.log(error);
        }
      );
    },
    getList(page) {
      this.showLoader();
      const dataForm = {
        search_keyword: this.searchKeyword,
        merchant_id: this.merchantId ?? 0,
        page: page,
      };

      ReportService.walletReport(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.members = response.data.data.items || [];
            this.pagination = response.data.data || {};
            this.page = this.pagination.current_page || 1;
            this.hideLoader();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message =
            error.response?.data?.result?.message ||
            "An error occurred while fetching data";
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    search() {
      if (this.merchantId && this.merchantId != 0) {
        this.page = 1;
        this.getList(this.page);
      } else {
        this.snackbar = "danger";
        this.message = "Plese, select merchant!";
        this.setTimeOutNotification();
      }
    },
    handleFilterChange() {
      if (this.merchantId && this.merchantId != 0) {
        this.page = 1;
        this.getList(this.page);
      } else {
        this.snackbar = "danger";
        this.message = "Plese, select merchant!";
        this.setTimeOutNotification();
      }
    },
    closeSnackbar() {
      this.snackbar = null;
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.message-success {
  z-index: 9999;
}

.avatar {
  width: 40px;
  height: 40px;
  object-fit: cover;
}

.badge {
  padding: 0.5em 0.75em;
}

.btn-link {
  text-decoration: none;
  transition: opacity 0.2s;
}

.btn-link:hover {
  opacity: 0.8;
}

/* Enhanced Select Styles */
.custom-select {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  width: 100%;
}

.custom-select:hover {
  border-color: rgba(0, 0, 0, 0.25);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.custom-select:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
}

.form-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #344767;
  margin-bottom: 0.5rem;
  display: block;
}

.input-group-outline {
  border-radius: 0.5rem;
}

/* Export button container */
.d-flex.align-items-end {
  gap: 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .custom-select {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .row.align-items-center.mb-3 > div {
    margin-bottom: 1rem;
  }
  
  .d-flex.align-items-end {
    justify-content: flex-start;
    margin-top: 0.5rem;
  }
}
</style>
